module.exports = __webpack_public_path__ + "img/sheets.ade87af3.png";